import { render } from "./unreadEventsCount.vue?vue&type=template&id=5823a427"
import script from "./unreadEventsCount.vue?vue&type=script&lang=js"
export * from "./unreadEventsCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__